export const formatMoney = (amount: number | undefined, defaultValue: string = '-') => {
    if (amount == null || amount == undefined) return defaultValue;
    return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
};

export const formatNumber = (number: number | undefined) => {
    if (number == null || number == undefined) return '';
    return number.toLocaleString('fr-FR');
};


export const formatPercentage = (number: number | undefined) => {
    if (number == null || number == undefined) return '';
    return (number/100).toLocaleString('fr-FR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
};